import simpleStorage from '@/utils/simpleStorage'

import {REFERRAL_ID_KEY} from './const'

export default function getReferraId() {
  const rawReferralId = simpleStorage.get(REFERRAL_ID_KEY)
  if (!rawReferralId) return
  if (typeof rawReferralId !== 'string') return
  return rawReferralId
}
